import PropTypes from 'prop-types';

import s from './filterTabs.module.css';

const initOptions = [{ label: '---', value: '' }];

function FilterTabs({
  options = initOptions,
  filter,
  setFilter,
  disabled = false,
}) {
  return (
    <div className={s.selectors}>
      {options.map(({ label, value }) => (
        <button
          key={value}
          type="button"
          onClick={() => setFilter(value)}
          className={filter === value ? s.tab_active : s.tab}
          disabled={disabled}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default FilterTabs;

FilterTabs.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape),
  filter: PropTypes.string.isRequired,
  setFilter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
